<template>
  <div class="footer-container">
    <div class="indianart"></div>
    <div class="links">
      <router-link
        tag="div"
        class="link"
        :to="{ path: '/' + $route.params.lang + '/nav/' + link.name }"
        v-for="link in links"
        :key="link.id"
      >
        <i class="material-icons icon">{{ link.icon }}</i>
        {{ link.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['links']
}
</script>
<style lang="scss" scoped>
.footer-container {
  height: var(--loval-footer-height);
  position: relative;
}
.indianart {
  background-image: url(../assets/img/Footer_indianart.png);
  height: 15px;
  width: 100%;
  background-size: cover;
  background-position: center;
}
.links {
  height: calc(var(--loval-footer-height) - 15px);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.link {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.link::after {
  content: "";
  height: var(--font-size);
  width: var(--font-size);
  background-color: var(--dark-blue);
  border-radius: 50%;
  margin-left: 5px;
}
.router-link-active {
  font-weight: bold;
}
.icon {
  display: none;
}
@media only screen and (min-width: 1200px) {
  $scrollable-padding: 30px;
  .indianart {
    position: absolute;
    height: calc(#{$scrollable-padding} + 2px);
    top: -$scrollable-padding;
    left: 0;
    width: calc(100% - (#{$scrollable-padding} * 2));
    margin: 0 $scrollable-padding;
  }
  .links {
    height: var(--loval-footer-height);
  }
  .link {
    padding: 10px 20px;
  }
  .link:hover {
    background-color: #ddd;
    color: var(--white);
  }
  .icon {
    display: inline-block;
    padding-right: 10px;
  }
  .link::after {
    display: none;
  }
  .router-link-active {
    font-weight: unset;
  }
}
</style>
